//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_epsilon5 = 0.00001;\n\
";
